import { type FC, type ReactNode } from "react";

import { CardHeader as SDSCard } from "@snapchat/snap-design-system";

interface CardProps {
    title?: string;
    icon: ReactNode;
    loading?: boolean;
    className?: string;
    content?: ReactNode;
}

export const Card: FC<CardProps> = ({ title, icon, loading = false, className, content }) => {
    if (!loading) {
        // TODO: add logic for loading state
    }
    return <SDSCard title={title} icon={icon} className={className} rightHeaderContent={content} />;
};
